import React from "react";
import iconClose from "../../images/icon-cross.svg";
import iconSearch from "../../images/icon-search.svg";
import AnchorLink from "react-anchor-link-smooth-scroll";
import down from "../../images/to-down.svg";

const Search = () => {
  return (
    <div className="search">
      <div className="search__wrapper">
        <header className="search__header">
          <h3 className="search__title big-text">Поиск</h3>
          <button className="search__close">
            <img src={iconClose} alt="Закрыть поиск" />
          </button>
        </header>
        <div className="search__input-wrapper">
          <input
            type="search"
            className="search__input"
            placeholder="Что будем искать?"
            aria-label="Поиск по сайту"
          />
          <button className="search__submit">
            <img src={iconSearch} alt="Искать" />
          </button>
        </div>
        <footer className="search__footer">
          <div className="search__feedback">
            <p>Горячая линия Aquaart Group</p>
            <a href="tel:8800200-29-29" className="search__phone">
              8 800 200-29-29
            </a>
          </div>
          <AnchorLink className="lead__move-down" href="#about">
            <img src={down} width="120" height="120" alt="Вниз" />
          </AnchorLink>
        </footer>
      </div>
    </div>
  );
};

export default Search;
